export default __webpack_public_path__ + "static/media/Harness of the Kozak Slayer.dee30a26.jpg";